const getUrlSearchParams = (parameter = 'uitheme', queryString = window.location.search):string | null => {
    const params = new URLSearchParams(queryString)
    return params.get(parameter)
  }
  
  export default getUrlSearchParams